var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolderOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4102 4.875H13.125V3.5625C13.125 2.85156 12.5234 2.25 11.8125 2.25H7.4375L5.6875 0.5H1.3125C0.574219 0.5 0 1.10156 0 1.8125V9.6875C0 10.4258 0.574219 11 1.3125 11H12.25C12.6875 11 13.0977 10.7812 13.3438 10.3984L15.5312 6.89844C16.0781 6.02344 15.4492 4.875 14.4102 4.875ZM1.3125 1.97656C1.3125 1.89453 1.36719 1.8125 1.47656 1.8125H5.14062L6.89062 3.5625H11.6484C11.7305 3.5625 11.8125 3.64453 11.8125 3.72656V4.875H4.15625C3.69141 4.875 3.25391 5.12109 3.00781 5.53125L1.3125 8.375V1.97656ZM12.25 9.6875H1.96875L4.07422 6.1875H14.4375L12.25 9.6875Z",
    fill: "#808B9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderOpen);
export default __webpack_public_path__ + "static/media/folder-open.b383cd6691b6d077f07d116c869db69c.svg";
export { ForwardRef as ReactComponent };